module.exports = __webpack_public_path__ + "static/media/04.b5088c8d.jpg";